<template>
  <VMenu open-on-hover bottom offset-y content-class="elevation-2">
    <template #activator="{ on }">
      <a color="transparent" v-on="on">
        {{ title }}
      </a>
    </template>

    <VList :class="colorClass">
      <WithLocationSummaries v-slot="{ locations }">
        <div class="locations-dropdown">
          <VListTile
            v-for="(loc, index) in locations"
            :key="index"
            :to="`/locations/${loc.slug}`"
          >
            <VListTileTitle
              class="founders-grotesk--font font-weight-bold white--text"
              >{{ loc.title }}</VListTileTitle
            >
          </VListTile>
        </div>
      </WithLocationSummaries>
    </VList>
  </VMenu>
</template>

<script>
import WithLocationSummaries from '@dataProviders/WithLocationSummaries'

export default {
  name: 'BaseLocationsMenu',
  components: {
    WithLocationSummaries,
  },
  props: {
    title: {
      type: String,
      default: 'Locations',
    },
    colorClass: {
      type: String,
      default: '',
    },
  },
}
</script>